import React from 'react';
import { Link } from 'react-router-dom';
import { hasUserPermission, isSuperAdmin } from '../utils/userPermissions';

export const permissionForPath = path => {
  const normalized = (path || '').split(/[?#]/)[0].replace(/\/$/, '').toLowerCase();
  const listingModules = {
    '/admin': 'users', '/company': 'companies', '/cdeleted': 'companies',
    '/branches': 'branches', '/bdeleted': 'branches', '/customers': 'customers',
    '/departments': 'departments', '/industries': 'industries', '/sub-industries': 'industries',
    '/principals': 'principals', '/pdeleted': 'principals', '/product': 'product_categories',
    '/payment-terms': 'payment_terms', '/roles': 'roles', '/quotes': 'quotes', '/po-sales': 'po_sales',
  };
  if (listingModules[normalized]) return [listingModules[normalized], 'view'];
  if (normalized.startsWith('/convert-po-sales/')) return ['po_sales', 'add'];
  if (normalized.startsWith('/company-settings')) return ['companies', 'edit'];
  const match = normalized.match(/^\/(create-|edit\/)([^/]+)/);
  if (!match) return null;
  const modules = { admin: 'users', customer: 'customers', customers: 'customers', company: 'companies', branch: 'branches',
    departments: 'departments', industries: 'industries', 'sub-industries': 'industries', principal: 'principals',
    product: 'product_categories', category: 'product_categories', 'payment-term': 'payment_terms', role: 'roles', quote: 'quotes' };
  return modules[match[2]] ? [modules[match[2]], match[1] === 'create-' ? 'add' : 'edit'] : null;
};

const PermissionRoute = ({ path, admin, children }) => {
  const normalizedPath = (path || '').split(/[?#]/)[0].replace(/\/$/, '').toLowerCase();
  const superAdminPage = ['/dashboard/overview', '/admin', '/create-admin'].includes(normalizedPath) ||
    (/^\/edit\/admin\/\d+$/.test(normalizedPath) && normalizedPath !== '/edit/admin/' + admin?.id);
  if (isSuperAdmin(admin) && !superAdminPage) return <div className="py-5 text-center" role="alert">
    <h2>403 - Access denied</h2>
    <p>Super Admin can only access Vendor management and the Super Admin Dashboard.</p>
    <Link to="/dashboard/overview">Back to Dashboard</Link>
  </div>;
  const permission = permissionForPath(path);
  const ownProfile = admin?.id && path.toLowerCase() === '/edit/admin/' + admin.id;
  if (!permission || ownProfile || hasUserPermission(...permission, admin)) return <>{children}</>;
  return <div className="py-5 text-center" role="alert">
    <h2>Permission required</h2>
    <p>Your Vendor has not enabled this action for your account.</p>
    <Link to="/dashboard/overview">Back to Dashboard</Link>
  </div>;
};

export default PermissionRoute;
